var map = {
	"./": 5114,
	"./Cart": 64,
	"./Cart.js": 64,
	"./Delivered": 5071,
	"./Delivered.js": 5071,
	"./DetailUser": 4542,
	"./DetailUser.js": 4542,
	"./User": 5387,
	"./User.js": 5387,
	"./UserPage": 9053,
	"./UserPage.js": 9053,
	"./Voucher": 5459,
	"./Voucher.js": 5459,
	"./Wishlist": 4819,
	"./Wishlist.js": 4819,
	"./index": 5114,
	"./index.js": 5114
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4180;